import axios, { AxiosInstance } from 'axios';
import { emojiEliminateRequestInterceptor } from '@/shared/lib/emojiEliminate/interceptor';
import { configEnv } from '@/shared/config-env';

export let axiosLander: AxiosInstance = axios;

if (axios.create) {
  axiosLander = axios.create({
    baseURL: configEnv.LANDER_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    transformRequest: (data, headers) => {
      // @ts-ignore
      if (headers?.common?.Authorization) {
        // @ts-ignore
        delete headers.common.Authorization;
      }
      return data;
    },
  });

  axiosLander.interceptors.request.use(
    config => {
      emojiEliminateRequestInterceptor(config);
      return config;
    },
    error => {
      return Promise.reject(error);
    },
  );
}
